import ButtonBase from '@material-ui/core/ButtonBase'
import { makeStyles } from '@material-ui/core/styles'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

type EdgeCollapseButtonProps = {
  visible: boolean
  onExpand: () => void
}

const useStyles = makeStyles((theme) => ({
  button: {
    position: 'absolute',
    top: 30,
    left: 0,
    zIndex: 50,
    width: 28,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    borderRadius: '0 999px 999px 0',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    boxShadow: '0 6px 16px rgba(15,23,42,0.14)',
    overflow: 'visible',
    transition:
      'transform 200ms ease, color 200ms ease, background-color 200ms ease, box-shadow 200ms ease',
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
      boxShadow: '0 10px 22px rgba(15,23,42,0.18)',
      transform: 'scale(1.1)',
    },
    '&:hover $icon, &:hover $ghost': {
      animation: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(1),
    },
  },
  icon: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: '$expandNudge 1.8s ease-in-out infinite',
  },
  ghost: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    opacity: 0,
    pointerEvents: 'none',
    animation: '$expandGhost 1.8s ease-in-out infinite',
  },
  '@keyframes expandNudge': {
    '0%, 100%': {
      transform: 'translateX(-4px)',
    },
    '55%': {
      transform: 'translateX(-3.5px)',
    },
    '75%': {
      transform: 'translateX(-2px)',
    },
  },
  '@keyframes expandGhost': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-2px)',
    },
    '15%': {
      opacity: 0.45,
      transform: 'translateX(0px)',
    },
    '70%': {
      opacity: 0.18,
      transform: 'translateX(5px)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(8px)',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    icon: {
      animation: 'none',
    },
    ghost: {
      animation: 'none',
    },
  },
}))

const EdgeCollapseButton = ({ visible, onExpand }: EdgeCollapseButtonProps) => {
  const classes = useStyles()

  if (!visible) {
    return null
  }

  return (
    <ButtonBase className={classes.button} onClick={onExpand} aria-label="Open sidebar" title="Open sidebar">
      <span className={classes.icon}>
        <ChevronRightIcon fontSize="small" />
      </span>
      <span className={classes.ghost} aria-hidden="true">
        <ChevronRightIcon fontSize="small" />
      </span>
    </ButtonBase>
  )
}

export default EdgeCollapseButton
